import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { app } from "./firebaseConfig";

const auth = getAuth(app);

export default function Verify() {
  const navigate = useNavigate();

  useEffect(() => {
    const emailLink = window.location.href;

    if (isSignInWithEmailLink(auth, emailLink)) {
      let email = window.localStorage.getItem("emailForSignIn");

      if (!email) {
        email = prompt("Please enter your email to complete verification:");
        if (!email) {
          alert("❌ Verification failed. Email is required.");
          navigate("/");
          return;
        }
      }

      signInWithEmailLink(auth, email, emailLink)
        .then(() => {
          window.localStorage.removeItem("emailForSignIn");
          navigate(`/form?email=${email}`);
        })
        .catch((error) => {
          console.error("Verification error:", error);
          alert("❌ Email verification failed.");
          navigate("/");
        });
    } else {
      navigate("/");
    }
  }, [navigate]);

  return (
    <div className="verify-container">
      <h2 className="fade-in">Verifying your email...</h2>
    </div>
  );
}